import { logger as a } from "../../../utils/logger.js";
const t = /* @__PURE__ */ new Map(), h = 5e3;
function u(c, e) {
  return c.then((r) => (e.keepCacheOnSuccess || (e.timeMs ? setTimeout(() => {
    a.debug(`[decorator cache] [${e.key}] cache timeout`), t.delete(e.key);
  }, e.timeMs) : (a.debug(`[decorator cache] [${e.key}] cache timeout`), t.delete(e.key))), a.debug(`[decorator cache] [${e.key}] promise succeeded`), r)).catch((r) => {
    throw e.keepCacheOnError || (a.debug(`[decorator cache] [${e.key}] promise failed, clean the cache`), t.delete(e.key)), r;
  });
}
function i(c, e, r = h) {
  if (!t.get(c) || !r) {
    a.debug(`[decorator cache] [${c}] cache missing, create it`);
    const o = u(e(), { key: c, timeMs: r });
    t.set(c, o);
  }
  return a.debug(`[decorator cache] [${c}] cache exists`), t.get(c);
}
function s(c, e) {
  return u(e(), {
    key: c,
    timeMs: 0,
    // delete the cache immediately
    keepCacheOnError: !0
    // but keep the cache if the request is not successful
  });
}
function d(c, e, r = h) {
  const o = u(e(), { key: c, timeMs: r });
  return t.set(c, o), u(o, { key: c, timeMs: r });
}
function f(c, e, r = h) {
  return d(c, () => Promise.resolve(e), r);
}
function l(c) {
  t.forEach((e, r) => {
    r.startsWith(c) && t.delete(r);
  });
}
export {
  t as CACHE,
  i as cacheDecorator,
  l as deleteCache,
  s as invalidateCacheIfSuccessfulDecorator,
  d as networkFirstAndCacheDecorator,
  f as updateCache
};
